import { render } from "./PopoverPage.vue?vue&type=template&id=8770233c"
import script from "./PopoverPage.vue?vue&type=script&lang=js"
export * from "./PopoverPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__